// Core
import { useState, useRef, useEffect, Suspense } from 'react';
import { Flex, Box, Image, Grid, Text, Spinner, useDisclosure } from '@chakra-ui/react';
import { Canvas, useFrame } from '@react-three/fiber';
import { OrbitControls, useGLTF, Html, useProgress } from '@react-three/drei';
import { useSpring, animated } from '@react-spring/three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { MdToken } from 'react-icons/md';

// Components
import Controls from './components/Controls';
import StarsBackground from './components/StarsBackground.js';
import TokensRoad from './components/TokensRoad.js';
import TimerAndClaim from './components/TimerAndClaim.js';
import useLightAnimation from './components/Light';
import Model from './components/Model.js';
import { models } from '../../components/Settings/Models.js';

const Play = ({
  pagePlay,
  setPagePlay,
  sessionTokens,
  setSessionTokens,
  isClaim,
  setIsClaim,
  activeModel,
  setTokens
}) => {
  const { progress } = useProgress();
  const [isModelLoading, setIsModelLoading] = useState(true);
  const [modelPositionX, setModelPositionX] = useState(0);
  const [modelPositionY, setModelPositionY] = useState(-30);
  const [modelScale, setModelScale] = useState(models[activeModel].scale);
  const [model3dX, setModel3dX] = useState(0);
  const [roadPositionX, setRoadPositionX] = useState(-10);
  const [roadRotateZ, setRoadRotateZ] = useState(0);
  const [speed, setSpeed] = useState(4);
  const [speedNum, setSpeedNum] = useState(50);
  const [weightNum, setWeightNum] = useState(1000);
  const [rotateModelScale, setRotateModelScale] = useState(0.1);
  const [rotateRoadScale, setRotateRoadScale] = useState(8);
  const [isMovingLeft, setIsMovingLeft] = useState(false);
  const [isMovingRight, setIsMovingRight] = useState(false);
  const [isAccelerating, setIsAccelerating] = useState(false);  
  const [movingBoxesOpacity, setMovingBoxesOpacity] = useState(0); 
  const stationaryBoxRef = useRef(null);
  const { lightPosition, lightIntensity } = useLightAnimation(speed, roadRotateZ);

  return (

    <Box position="relative" h="100vh">
      <StarsBackground roadPositionX={roadPositionX} rotateRoadScale={rotateRoadScale} />

      <TimerAndClaim 
        sessionTokens={sessionTokens}
        setIsClaim={setIsClaim}
        setPagePlay={setPagePlay}
        setTokens={setTokens}
        setIsAccelerating={setIsAccelerating} />

      <TokensRoad 
        sessionTokens={sessionTokens} 
        setSessionTokens={setSessionTokens}
        speed={speed}
        movingBoxesOpacity={movingBoxesOpacity}
        roadRotateZ={roadRotateZ}
        roadPositionX={roadPositionX}
        rotateRoadScale={rotateRoadScale}
        stationaryBoxRef={stationaryBoxRef}/>

      <Model
        stationaryBoxRef={stationaryBoxRef}
        modelPositionX={modelPositionX}
        modelPositionY={modelPositionY}
        model3dX={model3dX}
        models={models}
        activeModel={activeModel}
        lightIntensity={lightIntensity}
        lightPosition={lightPosition}
        progress={progress}
        modelScale={modelScale}
        setIsModelLoading={setIsModelLoading}
        rotateModelScale={rotateModelScale}
      />

      {progress === 100 && (
        <Controls 
          isClaim={isClaim}
          setIsMovingLeft={setIsMovingLeft}
          setIsMovingRight={setIsMovingRight}
          setModelPositionX={setModelPositionX}
          setRoadPositionX={setRoadPositionX}
          setRoadRotateZ={setRoadRotateZ}
          setRotateModelScale={setRotateModelScale}
          setSpeed={setSpeed}
          setModelPositionY={setModelPositionY}
          setModelScale={setModelScale}
          setModel3dX={setModel3dX}
          setRotateRoadScale={setRotateRoadScale}
          setMovingBoxesOpacity={setMovingBoxesOpacity}
          setPagePlay={setPagePlay}
          setSessionTokens={setSessionTokens}
          isMovingLeft={isMovingLeft}
          isMovingRight={isMovingRight}
          models={models}
          activeModel={activeModel}
          isAccelerating={isAccelerating}
        />
      )}
    </Box>
  );
};

export default Play;
